import { useEffect, useState } from "react";
import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";
import Select from "../../../../components/Select";
import { JobRoleDetailService } from "../../../../services/JobRoleDetailService";
import { func } from "prop-types";
import { DropDownMultiCheck } from "../../AdvanceSearch/DropDownMultiCheck";

export default function BusinessAreaInterest({ searchObject, onChange, t }) {
  const [
    candidateInterestBusinessAreas,
    setCandidateInterestBusinessAreas
  ] = useState([]);

  useEffect(() => {
    JobRoleDetailService.getAllBusinessAreas().then((data) => {
      setCandidateInterestBusinessAreas(data);
    });
  }, []);
  function onchangeCandidateBusinessAreas(selecteds) {
    onChange({ target: { name: "candidateBusinessAreas", value: selecteds } });
  }

  return (
    <>
      <div>
        <legend className="fontsize-legend">
          {t("Business Area Interest")}
        </legend>{" "}
        <DropDownMultiCheck
          dataList={candidateInterestBusinessAreas}
          selecteds={searchObject.candidateBusinessAreas || []}
          setSelecteds={onchangeCandidateBusinessAreas}
          label={t("Business Area...")}
          hideSelected={true}
        />
        {/* <Select
          className="form-select fontsize-legend"
          name="candidateInterestBusinessAreaId"
          id="candidateInterestBusinessAreaId"
          onChange={onChange}
          value={searchObject.candidateInterestBusinessAreaId || ""}
        >
          <option></option>
          {candidateInterestBusinessAreas.map((candidateInterestBusinessArea) => (
            <option className="fontsize-legend" key={candidateInterestBusinessArea.id} value={candidateInterestBusinessArea.id}>
              {t(candidateInterestBusinessArea.description)}
            </option>
          ))}
        </Select> */}
      </div>
    </>
  );
}
